import { render, staticRenderFns } from "./PublicQuotationPages5.vue?vue&type=template&id=0fc68769&scoped=true&"
import script from "./PublicQuotationPages5.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc68769",
  null
  
)

export default component.exports